import { useEffect, useState } from 'react';
import { useWallet } from '../context/WalletContext';
import { useContracts } from './useContracts';

// Poll interval (ms). No React callbacks — pure setInterval driven.
const POLL_MS = 25000;

export const useUserData = () => {
  const { account } = useWallet();
  const c = useContracts();

  const [state, setState] = useState({
    loading: true,
    userId: 0n,
    summary: null,
    investments: [],
    contributors: [],
    grxBalance: 0n,
    usdtBalance: 0n,
    error: null,
  });

  useEffect(() => {
    let mounted = true;
    let timer;

    const load = async () => {
      if (!account) {
        if (mounted) setState((s) => ({ ...s, loading: false, userId: 0n, summary: null, investments: [], contributors: [] }));
        return;
      }
      try {
        const userId = await c.read.store.addressToId(account);
        const id = BigInt(userId);
        let summary = null;
        let investments = [];
        let contributors = [];
        if (id > 0n) {
          summary = await c.read.views.getUserSummary(id);
          const invCount = Number(summary.investmentCount);
          const cCount = Number(summary.contributorCount);
          if (invCount > 0) {
            investments = await c.read.views.getInvestmentsPage(id, 0, invCount);
          }
          if (cCount > 0) {
            contributors = await c.read.views.getContributorsPage(id, 0, cCount);
          }
        }
        let grxBalance = 0n, usdtBalance = 0n;
        try { grxBalance  = await c.read.grx.balanceOf(account); } catch {}
        try { usdtBalance = await c.read.usdt.balanceOf(account); } catch {}

        if (!mounted) return;
        setState({
          loading: false,
          userId: id,
          summary,
          investments,
          contributors,
          grxBalance,
          usdtBalance,
          error: null,
        });
      } catch (e) {
        if (!mounted) return;
        setState((s) => ({ ...s, loading: false, error: e?.message || 'Load failed' }));
      }
    };

    load();
    timer = setInterval(load, POLL_MS);
    return () => { mounted = false; clearInterval(timer); };
    // Only re-run when account changes (contracts object is memoised)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account]);

  return state;
};
